import React from 'react';
import styles from './HeaderButton.module.scss';

export default function HeaderButton({ onClick, children }) {
  return (
    <button className={styles.header_button} onClick={onClick}>
      {children}
    </button>
  );
}
